<script setup lang="ts">
  defineProps<{
    icon: string;
    label?: string;
  }>();
</script>

<template>
  <div role="button" :aria-label="label" class="rounded-sm p-2 w-icon h-icon box-content items-center justify-center bg-black-20 hover:bg-black-10 cursor-pointer text-white leading-none transition-colors">
    <des-icon :icon="icon" class="w-icon h-icon pointer-events-none" />
  </div>
</template>
